import React from 'react';
import './award.css';
import badge250Png from '../../../Assets/Images/award/training_magazine/2026 TMN Choice Award Badge Winner Immersive-250px.png';
import badge250Webp from '../../../Assets/Images/award/training_magazine/2026 TMN Choice Award Badge Winner Immersive-250px.webp';
import badge400Png from '../../../Assets/Images/award/training_magazine/2026 TMN Choice Award Badge Winner Immersive-400px.png';
import badge400Webp from '../../../Assets/Images/award/training_magazine/2026 TMN Choice Award Badge Winner Immersive-400px.webp';

export type AwardMarkSize = 'default' | 'sm' | 'lg' | 'xl';

interface AwardMarkProps {
	size?: AwardMarkSize;
	style?: React.CSSProperties;
}

// Official 2026 TMN winner badge, shown inside the circular .award-mark frame.
// Small frames use the 250px asset, large frames (80px+) use the 400px asset.
const AwardMark = ({ size = 'default', style }: AwardMarkProps) => {
	const modifier = size === 'default' ? '' : ` award-mark--${size}`;
	const large = size === 'lg' || size === 'xl';
	return (
		<span className={`award-mark${modifier}`} style={style}>
			<picture>
				<source type="image/webp" srcSet={large ? badge400Webp : badge250Webp} />
				<img
					src={large ? badge400Png : badge250Png}
					alt="2026 Training Magazine Network Choice Awards winner"
					width={large ? 400 : 250}
					height={large ? 400 : 250}
					loading="lazy"
					decoding="async"
				/>
			</picture>
		</span>
	);
};

export default AwardMark;
